import { render, staticRenderFns } from "./switcher-labels.vue?vue&type=template&id=08b62b60&"
import script from "./switcher-labels.vue?vue&type=script&lang=js&"
export * from "./switcher-labels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports